import { render } from "./ListingBuyBoxCard.vue?vue&type=template&id=45ddb630"
import script from "./ListingBuyBoxCard.vue?vue&type=script&lang=js"
export * from "./ListingBuyBoxCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__